import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import './PaginationView.scss';
import { useState, useEffect } from 'react';

export default function PaginationView({ currentPage, totalPage, onNext, onPrevious, onFoucsPage }: { currentPage: number, totalPage: number, onNext: () => void, onPrevious: () => void, onFoucsPage: (page: number) => void }) {

    const [jumpPage, setJumpPage] = useState<number | null>(null);
    const [isPhone, setIsPhone] = useState(false);
    const handleJumpPage = (e: React.FormEvent<HTMLInputElement>) => {
        e.preventDefault();
        if (jumpPage && jumpPage > totalPage) {
            onFoucsPage(totalPage);
        } else if (jumpPage && jumpPage < 1) {
            setJumpPage(1);
        } else if (jumpPage && jumpPage !== currentPage) {
            onFoucsPage(jumpPage);
        }
        setJumpPage(null);
    }
    useEffect(() => {
        // 根据正则是否是手机平板
        const isPhone = /Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);
        if (isPhone) {
            setIsPhone(true);
        }else{
            setIsPhone(false);
        }
    }, []);
    const renderPageNumbers = () => {
        if (totalPage <= 10) {
            // 总页数不超过10页时，显示所有页码
            return Array.from({ length: totalPage }, (_, index) => (
                <button
                    key={index + 1}
                    className={`pagination-page ${currentPage === index + 1 ? 'active' : ''}`}
                    onClick={() => onFoucsPage(index + 1)}
                >
                    {index + 1}
                </button>
            ));
        }

        // 总页数超过10页时的逻辑
        const pages = [];
        // 添加前3页
        if (currentPage > 3 && currentPage <= totalPage - 3) {
            pages.push(
                <button
                    key={1}
                    className={`pagination-page ${currentPage === 1 ? 'active' : ''}`}
                    onClick={() => onFoucsPage(1)}
                >
                    {1}
                </button>
            )
            pages.push(
                <span>...</span>
            )
            for (let i = currentPage - 2; i <= currentPage + 2; i++) {
                pages.push(
                    <button
                        key={i}
                        className={`pagination-page ${currentPage === i ? 'active' : ''}`}
                        onClick={() => onFoucsPage(i)}
                    >
                        {i}
                    </button>
                );
            }
            pages.push(
                <span>...</span>
            )
            pages.push(
                <button
                    key={totalPage}
                    className={`pagination-page ${currentPage === totalPage ? 'active' : ''}`}
                    onClick={() => onFoucsPage(totalPage)}
                >
                    {totalPage}
                </button>
            )
        } else if (currentPage <= 4) {
            for (let i = 1; i <= 5; i++) {
                pages.push(
                    <button
                        key={i}
                        className={`pagination-page ${currentPage === i ? 'active' : ''}`}
                        onClick={() => onFoucsPage(i)}
                    >
                        {i}
                    </button>
                );
            }
            if (currentPage > pages.length - 2) {
                pages.push(
                    <button
                        key={currentPage + 2}
                        className={`pagination-page ${currentPage === currentPage + 2 ? 'active' : ''}`}
                        onClick={() => onFoucsPage(currentPage + 2)}
                    >
                        {currentPage + 2}
                    </button>
                )
            }
            pages.push(
                <span>...</span>
            )
            pages.push(
                <button
                    key={totalPage}
                    className={`pagination-page ${currentPage === totalPage ? 'active' : ''}`}
                    onClick={() => onFoucsPage(totalPage)}
                >
                    {totalPage}
                </button>
            )
        } else if (currentPage > totalPage - 4) {
            pages.push(
                <button
                    key={1}
                    className={`pagination-page ${currentPage === 1 ? 'active' : ''}`}
                    onClick={() => onFoucsPage(1)}
                >
                    {1}
                </button>
            )
            pages.push(
                <span>...</span>
            )
            if (currentPage === totalPage - 3) {
                pages.push(
                    <button
                        key={currentPage - 2}
                        className={`pagination-page ${currentPage === currentPage - 2 ? 'active' : ''}`}
                        onClick={() => onFoucsPage(currentPage - 2)}
                    >
                        {currentPage - 2}
                    </button>
                )
            }
            for (let i = totalPage - 4; i <= totalPage; i++) {
                pages.push(
                    <button
                        key={i}
                        className={`pagination-page ${currentPage === i ? 'active' : ''}`}
                        onClick={() => onFoucsPage(i)}
                    >
                        {i}
                    </button>
                );
            }
        }
        return pages;
    };

    return (
        <div className={`pagination ${isPhone ? 'pagination-phone' : 'pagination-pc'}`}>
            {/* pc端 */}
            {
                !isPhone && <div className='pagination-pc pagination-content'>
                    <button
                        className="pagination-btn"
                        disabled={currentPage == 1 && totalPage == 0 || totalPage == 1 || currentPage == 1}
                        onClick={() => onPrevious()}
                    >
                        <LeftOutlined />
                    </button>
                    <div className="pagination-pages">
                        {renderPageNumbers()}
                    </div>
                    <button
                        className="pagination-btn"
                        disabled={currentPage == totalPage && totalPage != 0 && totalPage != 1 || totalPage == 0 || totalPage == 1}
                        onClick={() => onNext()}
                    >
                        <RightOutlined />
                    </button>
                    {
                    totalPage > 10 &&
                    <div className="pagination-jump">
                        <input type="number"
                            value={jumpPage || ''}
                            onChange={(e) => setJumpPage(parseInt(e.target.value))}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleJumpPage(e);
                                }
                            }}
                            placeholder="Jump to"
                        />
                    </div>
                }
                </div>
            }
            {/* 移动端 */}
            {
                isPhone && (
                    <div className='pagination-phone pagination-content'>
                        <div className="pagination-pages">
                            {renderPageNumbers()}
                        </div>
                        <div className="pagination-bottom">
                            <div className="all-pagination-btn">
                                <button
                                    className="pagination-btn"
                                    disabled={currentPage == 1 && totalPage == 0 || totalPage == 1 || currentPage == 1}
                                    onClick={() => onPrevious()}
                                >
                                    <LeftOutlined />
                                </button>
                                <button
                                    className="pagination-btn"
                                    disabled={currentPage == totalPage && totalPage != 0 && totalPage != 1 || totalPage == 0 || totalPage == 1}
                                    onClick={() => onNext()}
                                >
                                    <RightOutlined />
                                </button>
                            </div>
                            {
                                totalPage > 10 &&
                                <div className="pagination-jump">
                                    <input type="number"
                                        value={jumpPage || ''}
                                        onChange={(e) => setJumpPage(parseInt(e.target.value))}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleJumpPage(e);
                                            }
                                        }}
                                        placeholder="Jump to"
                                    />
                                </div>
                            }
                        </div>
                    </div>
                )
            }
        </div>
    )
}